import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";
import AddContactModal from "../../administration/ContactManagement/addContactModal";

export default function CreateContactDialog({ open, onClose, onSuccess }) {
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!open) {
      setIsSaving(false);
    }
  }, [open]);

  const handleClose = () => {
    if (isSaving) return;
    onClose?.();
  };

  return (
    <Dialog
      open={!!open}
      onClose={(event, reason) => {
        if (isSaving) return;
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          handleClose();
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown={isSaving}
      maxWidth="md"
      fullWidth
      scroll="paper"
      aria-labelledby="create-contact-dialog-title"
      PaperProps={{
        style: { maxHeight: "90vh", position: "relative" },
      }}
    >
      <DialogTitle
        id="create-contact-dialog-title"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 8,
        }}
      >
        Create Contact
        <IconButton
          aria-label="close"
          onClick={handleClose}
          size="small"
          disabled={isSaving}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="create-contact-dialog-content"
        style={{ paddingTop: 8, position: "relative" }}
      >
        {open ? (
          <AddContactModal
            isEmbedded
            onSavingChange={setIsSaving}
            onSuccess={(contact) => {
              onSuccess?.(contact);
              setIsSaving(false);
              onClose?.();
            }}
            onCancel={handleClose}
          />
        ) : null}
        {isSaving ? (
          <Box
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(255, 255, 255, 0.72)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            <CircularProgress size={40} style={{ color: "#000" }} />
          </Box>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
